import { render, staticRenderFns } from "./FeesPayment.vue?vue&type=template&id=90751b84"
import script from "./FeesPayment.vue?vue&type=script&lang=js"
export * from "./FeesPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports